import React, { useEffect, useState } from "react";
import Sidebar from "../components/Sidebar";
import DeleteIcon from "@mui/icons-material/Delete";
import InsertDriveFileOutlinedIcon from "@mui/icons-material/InsertDriveFileOutlined";
import { useDispatch, useSelector } from "react-redux";
import {
  adminActions,
  allQoutedAdaption,
  allQuotations,
  approveAdaptions,
  approveQoutes,
  deleteAdaption,
  deleteJob,
  pendingAdaptions,
  pendingAdaptionsAddToArchive,
  pendingQoutes,
  pendingQoutesAddToArchive,
  signOut,
} from "../store/adminSlice";
import { useNavigate } from "react-router-dom";
import HeaderScaff from "../components/HeaderScaff";
import { Dialog, IconButton, useMediaQuery } from "@mui/material";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import DoneIcon from "@mui/icons-material/Done";
import CloseIcon from "@mui/icons-material/Close";
import ThumbUpIcon from "@mui/icons-material/ThumbUp";
import ArchiveIcon from "@mui/icons-material/Archive";

import $ from "jquery";
import Swal from "sweetalert2";
$.DataTable = require("datatables.net");

function PendingProjectQoutes() {
  const navigate = useNavigate();
  const isNonMobile = useMediaQuery("(min-width: 768px)");
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [needed, setNeeded] = useState(false);
  const [data, setData] = useState([]);
  const dispatch = useDispatch();
  const statePendingQoutes = useSelector((state) => state.admin.pendingQoutes);
  const stateAllQuotationQuoted = useSelector(
    (state) => state.admin.allQuotationQuoted
  );
  const statePendingAdaptions = useSelector(
    (state) => state.admin.pendingAdaptions
  );
  const stateAllAdaptionQuoted = useSelector(
    (state) => state.admin.allQuotationAdaptionQuoted
  );
  const _id = useSelector((state) => state.admin._id);
  const subscribed = useSelector((state) => state.admin.subscribed);
  const statesignOut = useSelector((state) => state.admin.signOut);
  const swalAlert = useSelector((state) => state.admin.swalAlert);
  useEffect(() => {
    if (statesignOut === "signOut") {
      dispatch(signOut());
    }
  }, [statesignOut]);

  useEffect(() => {
    dispatch(pendingQoutes({ adminID: _id }));
    dispatch(pendingAdaptions({ adminID: _id }));
    dispatch(adminActions.setReloadToTrue());
    dispatch(adminActions.removeSwalAlert());
    dispatch(adminActions.removeEscaffFetched());
    dispatch(allQuotations({ adminID: _id }));
    dispatch(allQoutedAdaption({ adminID: _id }));
    if (isNonMobile) {
      setTimeout(() => {
        $("#table").DataTable({ pagingType: "simple_numbers", retrieve: true });
        $("#table1").DataTable({
          pagingType: "simple_numbers",
          retrieve: true,
        });
      }, 5000);
    }

    if (!isNonMobile) {
      setSidebarOpen(false);
    }
  }, []);
  useEffect(() => {
    dispatch(pendingQoutes({ adminID: _id }));
    dispatch(pendingAdaptions({ adminID: _id }));
    dispatch(adminActions.setReloadToTrue());
    dispatch(adminActions.removeSwalAlert());
    dispatch(adminActions.removeEscaffFetched());
    dispatch(allQuotations({ adminID: _id }));
    dispatch(allQoutedAdaption({ adminID: _id }));
    if (isNonMobile) {
      setTimeout(() => {
        $("#table").DataTable({ pagingType: "simple_numbers", retrieve: true });
        $("#table1").DataTable({
          pagingType: "simple_numbers",
          retrieve: true,
        });
      }, 5000);
    }
  }, [swalAlert]);

  const deletee = (id) => {
    dispatch(deleteJob({ _id: id, adminID: _id }));
  };
  const deleteee = (id) => {
    dispatch(deleteAdaption({ adaptionID: id, adminID: _id }));
  };

  useEffect(() => {
    if (!_id) {
      navigate("/signin");
    } else if (!subscribed) {
      navigate("/signin");
    }
  }, [_id, subscribed, statePendingQoutes]);

  const approveEscaffQoutes = (id, type) => {
    Swal.fire({
      title: "Do you want to aprrove this qoute?",
      text: "Approving this qoute bypasses the customer approval -if you are sure this is correct click yes below ! ",
      showDenyButton: true,

      confirmButtonText: "Yes",
      denyButtonText: "No",
      confirmButtonColor: "#60c088",
      customClass: {
        actions: "my-actions",

        confirmButton: "order-2",
        denyButton: "order-3",
      },
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(approveQoutes({ adminID: _id, id, type }));
      }
    });
  };
  const approveEscaffAdaptions = (id, type) => {
    console.log(id, type);
    Swal.fire({
      title: "Do you want to aprrove this adaption?",
      text: "Approving this adaption bypasses the customer approval -if you are sure this is correct click yes below ! ",
      showDenyButton: true,

      confirmButtonText: "Yes",
      denyButtonText: "No",
      confirmButtonColor: "#60c088",
      customClass: {
        actions: "my-actions",

        confirmButton: "order-2",
        denyButton: "order-3",
      },
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(approveAdaptions({ adminID: _id, id, type }));
      }
    });
  };
  const archieveJob = (id) => {
    dispatch(pendingQoutesAddToArchive({ _id: id, adminID: _id }));
  };
  const archieveAdaption = (id) => {
    dispatch(pendingAdaptionsAddToArchive({ _id: id, adminID: _id }));
  };

  // Render card for project quotes
  const renderProjectCard = (data) => {
    const result = stateAllQuotationQuoted.find((a) => a.jobID === data._id);
    const isQuoted = !!result;

    return (
      <div
        key={data._id}
        className="bg-white rounded-lg shadow-md mb-4 overflow-hidden border border-gray-200 transition-all hover:shadow-lg"
      >
        <div className="bg-[#66c18a] px-4 py-2 flex justify-between items-center">
          <h3 className="text-white font-medium text-lg md:text-xl truncate">
            {data.customer.customerCompanyName}
          </h3>
          <span
            className={`px-2 py-1 rounded-full text-xs md:text-sm font-medium ${
              isQuoted
                ? "bg-green-100 text-green-800"
                : "bg-yellow-100 text-yellow-800"
            }`}
          >
            {isQuoted ? "Quoted" : "Not Quoted"}
          </span>
        </div>

        <div className="p-4">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-3 mb-4">
            <div>
              <p className="text-xs md:text-sm text-gray-500">Job ID</p>
              <p className="font-medium md:text-base">{data.jobNumber}</p>
            </div>
            <div>
              <p className="text-xs md:text-sm text-gray-500">Type</p>
              <p className="font-medium md:text-base">
                {data.typeofScafollding === "0"
                  ? "Scaffolding"
                  : "Temporary Roof"}
              </p>
            </div>
            <div className="col-span-2">
              <p className="text-xs md:text-sm text-gray-500">Address</p>
              <p className="font-medium md:text-base">
                {data.job1} {data.job2}
              </p>
            </div>
          </div>

          <div className="mb-4">
            <p className="text-xs md:text-sm text-gray-500">Job Description</p>
            <p className="text-sm md:text-base">{data.jobDescription}</p>
          </div>

          <div className="mb-4 md:flex md:space-x-4">
            <div className="mb-3 md:mb-0 md:flex-1">
              <p className="text-xs md:text-sm text-gray-500">Email</p>
              <p className="font-medium md:text-base">{data.customer.email}</p>
            </div>
            <div className="md:w-1/3">
              <p className="text-xs md:text-sm text-gray-500">Telephone</p>
              <p className="font-medium md:text-base">
                {data.customer.telephone}
              </p>
            </div>
          </div>

          <div className="flex flex-wrap justify-between items-center">
            <div className="flex space-x-3 md:space-x-5">
              {isQuoted && (
                <div
                  className="flex flex-col items-center cursor-pointer group"
                  onClick={() =>
                    approveEscaffQoutes(
                      result._id,
                      data.typeofScafollding === "0" ? "0" : "1"
                    )
                  }
                >
                  <ThumbUpIcon
                    sx={{
                      width: isNonMobile ? "24px" : "20px",
                      height: isNonMobile ? "24px" : "20px",
                    }}
                    className="text-[#66c18a] group-hover:text-[#5ab17d] transition-colors"
                  />
                  <p className="text-xs md:text-sm">Approve</p>
                </div>
              )}

              <div
                className="flex flex-col items-center cursor-pointer group"
                onClick={() =>
                  navigate(
                    data.typeofScafollding === "0"
                      ? `/createquotation?id=${data._id}`
                      : `/temporaryroofquotes?id=${data._id}`
                  )
                }
              >
                <InsertDriveFileOutlinedIcon
                  sx={{
                    width: isNonMobile ? "24px" : "20px",
                    height: isNonMobile ? "24px" : "20px",
                  }}
                  className="text-[#66c18a] group-hover:text-[#5ab17d] transition-colors"
                />
                <p className="text-xs md:text-sm">Quote</p>
              </div>

              <div
                className="flex flex-col items-center cursor-pointer group"
                onClick={() => archieveJob(data._id)}
              >
                <ArchiveIcon
                  sx={{
                    width: isNonMobile ? "24px" : "20px",
                    height: isNonMobile ? "24px" : "20px",
                  }}
                  className="text-[#66c18a] group-hover:text-[#5ab17d] transition-colors"
                />
                <p className="text-xs md:text-sm">Archive</p>
              </div>

              <div
                className="flex flex-col items-center cursor-pointer group"
                onClick={() => deletee(data._id)}
              >
                <DeleteIcon
                  sx={{
                    width: isNonMobile ? "24px" : "20px",
                    height: isNonMobile ? "24px" : "20px",
                  }}
                  className="text-[#66c18a] group-hover:text-red-500 transition-colors"
                />
                <p className="text-xs md:text-sm">Delete</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  // Render card for adaption quotes
  const renderAdaptionCard = (data) => {
    const result = stateAllAdaptionQuoted.find(
      (a) => a.adaptionID === data._id
    );
    const isQuoted = !!result;

    return (
      <div
        key={data._id}
        className="bg-white rounded-lg shadow-md mb-4 overflow-hidden border border-gray-200 transition-all hover:shadow-lg"
      >
        <div className="bg-[#66c18a] px-4 py-2 flex justify-between items-center">
          <h3 className="text-white font-medium text-lg md:text-xl truncate">
            {data.customerID.customerCompanyName}
          </h3>
          <span
            className={`px-2 py-1 rounded-full text-xs md:text-sm font-medium ${
              isQuoted
                ? "bg-green-100 text-green-800"
                : "bg-yellow-100 text-yellow-800"
            }`}
          >
            {isQuoted ? "Quoted" : "Not Quoted"}
          </span>
        </div>

        <div className="p-4">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-3 mb-4">
            <div>
              <p className="text-xs md:text-sm text-gray-500">Job ID</p>
              <p className="font-medium md:text-base">{data.jobID.jobNumber}</p>
            </div>
            <div>
              <p className="text-xs md:text-sm text-gray-500">Type</p>
              <p className="font-medium md:text-base">
                {data.type === "escaffQoute" ? "Scaffolding" : "Temporary Roof"}
              </p>
            </div>
            <div className="col-span-2">
              <p className="text-xs md:text-sm text-gray-500">Address</p>
              <p className="font-medium md:text-base">
                {data.jobID.job1} {data.jobID.job2}
              </p>
            </div>
          </div>

          <div className="mb-4 md:flex md:space-x-4">
            <div className="mb-3 md:mb-0 md:flex-1">
              <p className="text-xs md:text-sm text-gray-500">
                Job Description
              </p>
              <p className="text-sm md:text-base">
                {data.jobID.jobDescription}
              </p>
            </div>
            <div className="mb-3 md:mb-0 md:flex-1">
              <p className="text-xs md:text-sm text-gray-500">
                Adaption Details
              </p>
              <p className="text-sm md:text-base">{data.adaptionDetails}</p>
            </div>
          </div>

          <div className="mb-4 md:flex md:space-x-4">
            <div className="mb-3 md:mb-0 md:flex-1">
              <p className="text-xs md:text-sm text-gray-500">Email</p>
              <p className="font-medium md:text-base">
                {data.customerID.email}
              </p>
            </div>
            <div className="md:w-1/3">
              <p className="text-xs md:text-sm text-gray-500">Telephone</p>
              <p className="font-medium md:text-base">
                {data.customerID.telephone}
              </p>
            </div>
          </div>

          <div className="flex flex-wrap justify-between items-center">
            <div className="flex space-x-3 md:space-x-5">
              {isQuoted && (
                <div
                  className="flex flex-col items-center cursor-pointer group"
                  onClick={() =>
                    approveEscaffAdaptions(
                      result._id,
                      data.type === "escaffQoute" ? "0" : "1"
                    )
                  }
                >
                  <ThumbUpIcon
                    sx={{
                      width: isNonMobile ? "24px" : "20px",
                      height: isNonMobile ? "24px" : "20px",
                    }}
                    className="text-[#66c18a] group-hover:text-[#5ab17d] transition-colors"
                  />
                  <p className="text-xs md:text-sm">Approve</p>
                </div>
              )}

              <div
                className="flex flex-col items-center cursor-pointer group"
                onClick={() =>
                  navigate(
                    data.type === "escaffQoute"
                      ? `/createadaptionqoutation?adaptionID=${data._id}&id=${data.jobID._id}`
                      : `/temporaryroofadaptionQuotes?adaptionID=${data._id}&id=${data.jobID._id}`
                  )
                }
              >
                <InsertDriveFileOutlinedIcon
                  sx={{
                    width: isNonMobile ? "24px" : "20px",
                    height: isNonMobile ? "24px" : "20px",
                  }}
                  className="text-[#66c18a] group-hover:text-[#5ab17d] transition-colors"
                />
                <p className="text-xs md:text-sm">Quote</p>
              </div>

              <div
                className="flex flex-col items-center cursor-pointer group"
                onClick={() => archieveAdaption(data._id)}
              >
                <ArchiveIcon
                  sx={{
                    width: isNonMobile ? "24px" : "20px",
                    height: isNonMobile ? "24px" : "20px",
                  }}
                  className="text-[#66c18a] group-hover:text-[#5ab17d] transition-colors"
                />
                <p className="text-xs md:text-sm">Archive</p>
              </div>

              <div
                className="flex flex-col items-center cursor-pointer group"
                onClick={() => deleteee(data._id)}
              >
                <DeleteIcon
                  sx={{
                    width: isNonMobile ? "24px" : "20px",
                    height: isNonMobile ? "24px" : "20px",
                  }}
                  className="text-[#66c18a] group-hover:text-red-500 transition-colors"
                />
                <p className="text-xs md:text-sm">Delete</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className="w-full h-full">
      <HeaderScaff setSidebarOpen={setSidebarOpen} />
      <div
        className={`${
          sidebarOpen ? "" : isNonMobile ? "" : "flex-col"
        } 'w-full flex h-auto p-2 sm:p-6'`}
      >
        <div
          className={`${
            sidebarOpen
              ? isNonMobile
                ? "basis-1/5"
                : "flex justify-center w-full"
              : "hidden"
          } " h-full"`}
        >
          <Sidebar
            setSidebarOpen={setSidebarOpen}
            needed={needed}
            isNonMobile={isNonMobile}
          />
        </div>

        <div
          onClick={() => setSidebarOpen(true)}
          className={`${
            sidebarOpen
              ? isNonMobile
                ? "hidden"
                : "hidden"
              : isNonMobile
              ? "flex w-12 mt-4"
              : "flex border-2 border-x-0 bg-gray-100/50 mt-2 -mb-1 w-full items-center justify-center"
          } h-fit`}
        >
          <div
            className={`${
              sidebarOpen
                ? isNonMobile
                  ? ""
                  : ""
                : isNonMobile
                ? ""
                : "hidden"
            } `}
          >
            <IconButton onClick={() => setSidebarOpen(true)}>
              <ArrowForwardIosIcon />
            </IconButton>
          </div>
          <div
            className={`${
              sidebarOpen
                ? isNonMobile
                  ? "hidden"
                  : "hidden"
                : isNonMobile
                ? "hidden"
                : "flex"
            } `}
          >
            <p className="text-gray-500 text-xs py-[2px]">Sidebar</p>
          </div>
        </div>
        <div
          className={`${
            sidebarOpen ? (isNonMobile ? "" : "hidden") : ""
          } 'flex flex-col w-full lg:basis-3/4 '`}
        >
          {/* Main content container */}
          <div
            className={`${
              sidebarOpen ? (isNonMobile ? "w-full" : "hidden") : "w-full"
            } " "`}
          >
            <p className="text-lg xxl:text-2xl text-slate-600 font-medium pb-1 ml-2 mt-4 mb-3">
              Pending Project Quotes
            </p>

            {isNonMobile ? (
              // Desktop Card View for Project Quotes
              <div className="w-full px-2 mt-2 md:grid md:grid-cols-2 lg:grid-cols-1 xl:grid-cols-2 md:gap-4">
                {statePendingQoutes.length === 0 ? (
                  <p className="text-center text-gray-500 my-4 md:col-span-2 lg:col-span-1 xl:col-span-2">
                    No pending project quotes available
                  </p>
                ) : (
                  statePendingQoutes.map((data) => {
                    var result = stateAllQuotationQuoted.find(
                      (a) => a.jobID == data._id
                    );
                    if (result === undefined || result.approved === 0) {
                      return renderProjectCard(data);
                    }
                    return null;
                  })
                )}
              </div>
            ) : (
              // Mobile Table View is hidden now
              <div className="hidden lg:w-full overflow-x-auto lg:overflow-x-hidden pr-1">
                {/* Original table code hidden */}
              </div>
            )}

            <p className="text-lg xxl:text-2xl text-slate-600 font-medium pb-1 ml-2 mt-8 mb-3">
              Pending Adaption Quotes
            </p>

            {isNonMobile ? (
              // Desktop Card View for Adaption Quotes
              <div className="w-full px-2 mt-2 md:grid md:grid-cols-2 lg:grid-cols-1 xl:grid-cols-2 md:gap-4">
                {statePendingAdaptions.length === 0 ? (
                  <p className="text-center text-gray-500 my-4 md:col-span-2 lg:col-span-1 xl:col-span-2">
                    No pending adaption quotes available
                  </p>
                ) : (
                  statePendingAdaptions.map((data) => {
                    var result = stateAllAdaptionQuoted.find(
                      (a) => a.adaptionID === data._id
                    );
                    if (result === undefined || result.approved === 0) {
                      return renderAdaptionCard(data);
                    }
                    return null;
                  })
                )}
              </div>
            ) : (
              // Mobile Table View is hidden now
              <div className="hidden lg:w-full overflow-x-auto lg:overflow-x-hidden pr-1">
                {/* Original table code hidden */}
              </div>
            )}
          </div>
        </div>

        {/* Mobile content section - Only visible when sidebar is closed on mobile */}
        {!isNonMobile && !sidebarOpen && (
          <div className="w-full pb-20">
            <div className="w-full flex justify-between mt-4 px-2">
              <div className="flex space-x-2">
                <p className="text-base text-slate-700 pb-1 font-medium whitespace-nowrap">
                  Pending Project Quotes
                </p>
              </div>
            </div>

            {/* Mobile Card View for Project Quotes */}
            <div className="w-full px-2 mt-2">
              {statePendingQoutes.length === 0 ? (
                <p className="text-center text-gray-500 my-4">
                  No pending project quotes available
                </p>
              ) : (
                statePendingQoutes.map((data) => {
                  var result = stateAllQuotationQuoted.find(
                    (a) => a.jobID == data._id
                  );
                  if (result === undefined || result.approved === 0) {
                    return renderProjectCard(data);
                  }
                  return null;
                })
              )}
            </div>

            <div className="w-full flex justify-between mt-8 px-2">
              <div className="flex space-x-2">
                <p className="text-base text-slate-700 pb-1 font-medium whitespace-nowrap">
                  Pending Adaption Quotes
                </p>
              </div>
            </div>

            {/* Mobile Card View for Adaption Quotes */}
            <div className="w-full px-2 mt-2">
              {statePendingAdaptions.length === 0 ? (
                <p className="text-center text-gray-500 my-4">
                  No pending adaption quotes available
                </p>
              ) : (
                statePendingAdaptions.map((data) => {
                  var result = stateAllAdaptionQuoted.find(
                    (a) => a.adaptionID === data._id
                  );
                  if (result === undefined || result.approved === 0) {
                    return renderAdaptionCard(data);
                  }
                  return null;
                })
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default PendingProjectQoutes;
